export default __webpack_public_path__ + "static/media/atbs-logo.de77c6a9.svg";